import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from "@angular/core";

import { AppLoaderComponent } from "../../../shared/app-loader/app-loader.component";
import { Mimetype } from "../../../shared/mimetype";
import { validateViewerAndContentType, ViewerContent, ViewerType } from "./file-viewer.type";
import { AnnotationControllerComponent } from "../../annotation-controller/annotation-controller.component";

@Component({
   selector: "app-file-viewer",
   templateUrl: "./file-viewer.component.html",
   styleUrls: ["./file-viewer.component.css"],
})
export class FileViewerComponent implements OnChanges {
   @Input() viewerType: ViewerType = "other";
   @Input() content?: ViewerContent<typeof this.viewerType>;

   @Output() clickDownload = new EventEmitter();

   @ViewChild(AppLoaderComponent) protected loader: AppLoaderComponent;
   @ViewChild(AnnotationControllerComponent) pdfTronComp: AnnotationControllerComponent;

   protected loaded: boolean;

   ngOnChanges(): void {
      this.loaded = false;
      if ((<ViewerType[]>["image", "audio", "video"]).includes(this.viewerType)) {
         this.loader?.show();
      }
   }

   //==============================================================================================================
   // LOADER
   //==============================================================================================================

   onDataLoaded(): void {
      this.loaded = true;
      this.loader?.hide();
   }

   //==============================================================================================================
   // VIEWER: CANNOT-PREVIEW
   //==============================================================================================================

   /**
    * Cast the type from *ViewerContent\<ViewerType>* to the exact type of the input that the viewer requires.
    *
    * Compile error if the type of viewerContent is NOT compatible with the *expectedViewerType*.
    *
    * @example
    * confirmContentType(textContent, "text");
    * // ✅ Return textContent as ViewerContent<"text"> (string)
    *
    * confirmContentType(documentContent, "document");
    * // ✅ Return documentContent as ViewerContent<"document"> (DocumentData)
    *
    * confirmContentType(documentContent, "text");
    * // ❌ Compile error: Argument of type 'DocumentData' is not assignable to parameter of type 'string'.
    *
    * @usage
    * <app-sign-pdftron [documentData]="confirmContentType(content, 'document')"></app-sign-pdftron>
    */
   confirmContentType<VT extends ViewerType>(
      viewerContent: ViewerContent<ViewerType>,
      expectedViewerType: VT
   ): ViewerContent<VT> {
      if (validateViewerAndContentType(viewerContent, expectedViewerType)) {
         return viewerContent as ViewerContent<VT>;
      }
   }

   getIcon(): string {
      return Mimetype.getIcon(undefined);
   }

   download(): void {
      this.clickDownload.emit();
   }
}
